import { motion } from 'framer-motion'
import moment from 'moment'

import {
  MANAGEMENT_QUERY_KEY_SEARCH_NON_ALLOCATED_SIMS,
  useManagementDeleteNonAllocatedSim
} from '@apps-common/apis/management/non-allocated-sim'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg } from '@apps-common/components/layout'
import { ConfirmModal, ConfirmModalAction, ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { queryClient } from '@apps-common/lib'
import { INonAllocatedSimModel } from '@apps-common/types/management/non-allocated-sim'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

interface IProps {
  simApns: ISimApnModel[]
  sim: INonAllocatedSimModel
}
export const NonAllocatedSimListCard = ({ simApns, sim }: IProps) => {
  const { id, simApnId, simNo, mobileNo, ip, dateLoaded } = sim

  const { mutate, isPending } = useManagementDeleteNonAllocatedSim(true, () => {
    queryClient.invalidateQueries({ queryKey: MANAGEMENT_QUERY_KEY_SEARCH_NON_ALLOCATED_SIMS() })
  })

  const apn = simApns?.find((sa) => sa.simApnId === simApnId)

  return (
    <motion.div variants={GRID_CARD_VARIANTS} className='w-full p-6 rounded-[35px] bg-surface text-text border border-border5'>
      <div className='flex items-center justify-end w-full'>
        <div className='jost-bold text-[0.7em] opacity-60'>{moment(dateLoaded).format('DD/MM/YYYY')}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>SIM</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{simNo}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>MOB</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{mobileNo}</p>
        </div>
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>IP</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{ip}</p>
        </div>
        {apn && (
          <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
            <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>APN</p>
            <p className='jost-light text-ellipsis overflow-hidden'>{apn.simApnName}</p>
          </div>
        )}
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={ConfirmModal}
        disabled={isPending}
        componentProps={{
          text: 'Delete',
          description: 'Confirm you would like to delete this sim.',
          action: ConfirmModalAction.Error
        }}
        confirmCallback={() => {
          mutate({ id })
        }}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Delete'
          icon={<commonIcons.delete />}
          className='action-error !grow-0'
          iconContainerClassName='bg-error text-on-error'
        />
      </ModalButton>
    </motion.div>
  )
}
